"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hand = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Hand = function Hand() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M21 13.74v1.67a6 6 0 01-.79 3L17.58 23a2 2 0 01-1.74 1H11.7a2 2 0 01-1.25-.44l-3.09-3.19a5.999 5.999 0 01-.67-.84l-1.12-1.67A2.94 2.94 0 004 16.68l-1.34-.45-.36-.12a.49.49 0 01-.3-.48v-.14A1.49 1.49 0 013.5 14h.84a4 4 0 011.28.2L8 15V2.5a1.5 1.5 0 113 0v8a.5.5 0 101 0V8h3.26a3 3 0 012.12.88l2.74 2.74a3 3 0 01.88 2.12z"
  });
};

exports.Hand = Hand;